import 'slick-carousel';

// Rooms and Suites Slider
function changeSliderData() {
  const name = document.querySelector('.rass__name');
  const titleInfo = document.querySelector('.rass__title-info');
  const link = document.querySelector('.rass__link');
  const image = document.querySelector('.rass .slick-active img');

  name.innerHTML = (image.dataset.name || ' ');
  titleInfo.innerHTML = (image.dataset.title || ' ');
  if(image.dataset.text && image.dataset.href) {
    link.removeAttribute('hidden');
    link.innerHTML = image.dataset.text;
    link.href = image.dataset.href;
    link.setAttribute('manual_cm_sp', image.dataset.ibm);
  } else {
    link.setAttribute('hidden', 'hidden');
  }
}

// Initial slider event
$('.rass__slider').on('init', changeSliderData);

// Slick slider
const rassSlider = $('.rass__slider').slick({
  prevArrow: '<button class="rass__btn rass__btn--prev"></button>',
  nextArrow: '<button class="rass__btn rass__btn--next"></button>',
  dots: true,
  appendDots: $('.rass__dots'),
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        arrows: false,
        variableWidth: true,
        centerMode: true,
        adaptiveHeight: false
      }
    }
  ]
});

// After change slider event
rassSlider.on('afterChange', changeSliderData);
